export default function() {
      let videos = document.querySelectorAll('iframe, video')
      videos.forEach(function (video) {
        if (video.tagName.toLowerCase() === 'video') {
          video.pause
        } else {
          let src = video.src
          video.src = src
        }
      })
}
